'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from 'cn';
type LabelProps = React.ComponentProps<'label'>;
export function Label(props) {
  const $ = _c(12);
  let children;
  let className;
  let htmlFor;
  let rest;
  if ($[0] !== props) {
    ({
      children,
      className,
      htmlFor,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = htmlFor;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    htmlFor = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] !== className) {
    t0 = cn("flex items-center gap-2 text-sm leading-none font-medium select-none", "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50", "peer-disabled:cursor-not-allowed peer-disabled:opacity-50", "peer-data-disabled:cursor-not-allowed peer-data-disabled:opacity-50", className);
    $[5] = className;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== children || $[8] !== htmlFor || $[9] !== rest || $[10] !== t0) {
    t1 = <label data-slot="label" htmlFor={htmlFor} className={t0} {...rest}>{children}</label>;
    $[7] = children;
    $[8] = htmlFor;
    $[9] = rest;
    $[10] = t0;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}